module.exports = __webpack_public_path__ + "static/media/Twitter_Verified_Badge.c464ddee.svg";